module.exports = __webpack_public_path__ + "static/media/landing-illustration.b8a81f8f.svg";